"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function UndrawNetworknew(p) {
    var primaryColor = p.primaryColor, height = p.height, style = p.style, props = __rest(p, ["primaryColor", "height", "style"]);
    var styleProps = __assign({ width: "100%", height: height }, style);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", width: "1em", height: "1em", viewBox: "0 0 888 710.807", style: styleProps }, props),
        React.createElement("path", { d: "M444.936 604.807a260.064 260.064 0 11183.893-76.17 258.365 258.365 0 01-183.893 76.17zm0-518.129c-142.297 0-258.065 115.768-258.065 258.065S302.64 602.807 444.936 602.807 703 487.04 703 344.743 587.232 86.678 444.936 86.678z", fill: "#ccc" }),
        React.createElement("path", { fill: "#2f2e41", d: "M541.5 381.807v262h-195v-262z" }),
        React.createElement("path", { fill: "#3f3d56", d: "M313 373.807h262v104H313zM313 489.807h262v104H313zM313 605.807h262v104H313z" }),
        React.createElement("path", { fill: "#f9a826", d: "M313 417.904h262v16H313zM313 533.904h262v16H313zM313 649.904h262v16H313z" }),
        React.createElement("circle", { cx: 524, cy: 388.807, r: 6, fill: "#f9a826" }),
        React.createElement("circle", { cx: 545, cy: 388.807, r: 6, fill: "#f9a826" }),
        React.createElement("circle", { cx: 566, cy: 388.807, r: 6, fill: "#f9a826" }),
        React.createElement("circle", { cx: 524, cy: 502.807, r: 6, fill: "#f9a826" }),
        React.createElement("circle", { cx: 545, cy: 502.807, r: 6, fill: "#f9a826" }),
        React.createElement("circle", { cx: 566, cy: 502.807, r: 6, fill: "#f9a826" }),
        React.createElement("circle", { cx: 524, cy: 616.807, r: 6, fill: "#f9a826" }),
        React.createElement("circle", { cx: 545, cy: 616.807, r: 6, fill: "#f9a826" }),
        React.createElement("circle", { cx: 566, cy: 616.807, r: 6, fill: "#f9a826" }),
        React.createElement("path", { fill: "#3f3d56", d: "M0 708.807h888v2H0z" }),
        React.createElement("path", { d: "M241.879 271.065v185.991a14.675 14.675 0 01-14.673 14.673h-72.278a14.677 14.677 0 01-14.678-14.673V271.065a14.677 14.677 0 0114.678-14.673h8.768A6.978 6.978 0 00170.15 266h41.208a6.978 6.978 0 006.455-9.607h9.392a14.675 14.675 0 0114.673 14.673z", fill: "#e6e6e6" }),
        React.createElement("path", { fill: "#fff", d: "M145.064 291.91h92v128h-92z" }),
        React.createElement("path", { fill: "#e6e6e6", d: "M171.186 379.927h36.72v2.098h-36.72z" }),
        React.createElement("path", { fill: "#f9a826", d: "M171.149 387.632h56.817v2.098h-56.817z" }),
        React.createElement("path", { fill: "#e6e6e6", d: "M171.149 394.89h44.588v2.098h-44.588zM171.149 402.149h26.228v2.098h-26.228zM171.149 409.407h39.343v2.098h-39.343zM154.533 379.324h4.197v4.197h-4.197z" }),
        React.createElement("path", { fill: "#f9a826", d: "M154.533 386.582h4.197v4.197h-4.197z" }),
        React.createElement("path", { fill: "#e6e6e6", d: "M154.533 393.841h4.197v4.197h-4.197zM154.533 401.1h4.197v4.197h-4.197zM154.533 408.358h4.197v4.197h-4.197zM172.751 307.91h36.998v36.998h-36.998zM321.111.139h245.884v157.475H321.111z" }),
        React.createElement("path", { fill: "#fff", d: "M339.647 44.195h203.861v77.035H339.647z" }),
        React.createElement("path", { fill: "#e6e6e6", d: "M376.789 57.542h48.927v2.796h-48.927z" }),
        React.createElement("path", { fill: "#f9a826", d: "M376.74 67.807h75.705v2.796H376.74z" }),
        React.createElement("path", { fill: "#e6e6e6", d: "M376.74 77.479h59.411v2.796H376.74zM376.74 87.151h34.948v2.796H376.74zM376.74 96.822h52.422v2.796H376.74zM354.601 56.738h5.592v5.592h-5.592z" }),
        React.createElement("path", { fill: "#f9a826", d: "M354.601 66.409h5.592v5.592h-5.592z" }),
        React.createElement("path", { fill: "#e6e6e6", d: "M354.601 76.081h5.592v5.592h-5.592zM354.601 85.753h5.592v5.592h-5.592zM354.601 95.424h5.592v5.592h-5.592zM483.445 53.847h50.059v50.059h-50.059z" }),
        React.createElement("path", { fill: "#f9a826", d: "M321.006 0H566.89v10.446H321.006z" }),
        React.createElement("circle", { cx: 328.768, cy: 5.341, r: 2.097, fill: "#fff" }),
        React.createElement("circle", { cx: 336.117, cy: 5.341, r: 2.097, fill: "#fff" }),
        React.createElement("circle", { cx: 343.466, cy: 5.341, r: 2.097, fill: "#fff" }),
        React.createElement("path", { fill: "#e6e6e6", d: "M671.648 294.807h60v31h-60zM671.648 405.807h60v31h-60z" }),
        React.createElement("circle", { cx: 701.648, cy: 365.807, r: 50, fill: "#e6e6e6" }),
        React.createElement("circle", { cx: 701.648, cy: 365.807, r: 39, fill: "#fff" }),
        React.createElement("path", { fill: "#e2e2e2", d: "M688.877 355.122h30.247v1.728h-30.247z" }),
        React.createElement("path", { fill: "#f9a826", d: "M688.846 361.468h46.802v1.728h-46.802z" }),
        React.createElement("path", { fill: "#e2e2e2", d: "M688.846 367.447h36.728v1.728h-36.728zM688.846 373.426h21.605v1.728h-21.605zM688.846 379.405h32.407v1.728h-32.407zM675.16 354.625h3.457v3.457h-3.457z" }),
        React.createElement("path", { fill: "#f9a826", d: "M675.16 360.604h3.457v3.457h-3.457z" }),
        React.createElement("path", { fill: "#e2e2e2", d: "M675.16 366.583h3.457v3.457h-3.457zM675.16 372.562h3.457v3.457h-3.457zM675.16 378.541h3.457v3.457h-3.457z" })));
}
exports.default = UndrawNetworknew;
